import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const coDriverActiveAtom = atomWithStorage<boolean>('co-driver-active', true);

/**
 * Whether "Rate my VDP" can be sent, as CoDriver reports it:
 * - `loading`: the VIN insights or a reply are still coming
 * - `ready`: the prompt can be sent
 * - `sent`: this VIN's VDP was already rated
 */
export type RateMyVdpStatus = 'loading' | 'ready' | 'sent';

export const rateMyVdpStatusAtom = atom<RateMyVdpStatus>('loading');

/**
 * Set (to a timestamp) by "Rate my VDP" buttons outside CoDriver. CoDriver opens, waits for the VIN
 * insights so the prompt continues their conversation, sends it and clears the request.
 */
export const rateMyVdpRequestAtom = atom<number | null>(null);
